<template>
  <v-app id="cust-app">
    <v-app-bar v-if="mobile" id="id-app-bar" height="95" elevation="0">
      <template v-slot:prepend>
        <div to="/">
          <a class="d-flex flex-column align-items-center px-4" style="text-decoration: none;" href="/">
            <img :src="require('@/assets/NasBizAdLogo_whiteWord.png')" width="100" class="img-fluid">
          </a>
        </div>
      </template>
      <template v-slot:append>
        <v-app-bar-nav-icon id="nav-icon" @click.stop="drawer = !drawer" ></v-app-bar-nav-icon>
      </template>
    </v-app-bar>

    <!-- v-navigation-drawer will misbehave if width isn't supplied with numeric number in px -->
    <v-navigation-drawer id="nav-drawer" v-if="mobile" location="right" :width="vp_width" touchless v-model="drawer" class="text-bg-grey" 
    style="z-index: 2000 !important; border-left-width: 0px; top: 0px; height: 100dvh; padding-top: 5px;">
      <div class="w-100">
        <div class="d-flex align-items-center justify-space-between">
            <a class="d-flex flex-column align-items-center px-4" style="text-decoration: none;" href="/">
              <img :src="require('@/assets/NasBizAdLogo_whiteWord.png')" width="100" class="img-fluid">
              <span class="font-veryverysmall font-white">MAXIMISING YOUR BUSINESS POTENTIAL</span>
            </a>
          <button type="button" class="btn-close btn-close-white px-5" @click="drawer=false" aria-label="Close"></button>
        </div>
        <v-list class="pa-4">
          <v-list-item :to="menu_item.link" class="nav-link p-3" v-for="(menu_item, menu_item_idx) in app_bar_menu" :key="menu_item_idx" >
            <v-list-item-title class="nav-link-orange">{{ menu_item.display }}</v-list-item-title>
          </v-list-item>
        </v-list>
        <span class="nav-link d-flex align-items-lg-center justify-content-lg-center px-7 py-2 ">
          <span><img :src="require('@/assets/language_globe.png')" width="25" style="filter: invert(67%) sepia(84%) saturate(280%) hue-rotate(353deg) brightness(106%) contrast(89%);" ></span>
          <span class="d-lg-none nav-link-orange ms-1">EN</span>
        </span>
      </div>
    </v-navigation-drawer>

    <!-- MOBILE ENDS -->

    <v-app-bar v-if="!mobile" height="95" elevation="0" id="id-app-bar">
      <div class="w-100 d-flex align-items-center px-12">
        <a href="/">
          <div class="text-center font-white">
            <div> <span> <img :src="require('@/assets/NasBizAdLogo_whiteWord.png')" width="100" height="85" class="img-fluid" /> </span> </div>
          </div>
        </a>
        <div class="w-100 d-flex align-items-center justify-content-end">
          <div class="d-flex">
            <router-link v-for="(menu_item, menu_item_idx) in app_bar_menu" :key="menu_item_idx" class="nav-link p-3 d-flex align-items-center" aria-current="page" :to="menu_item.link">
              <span>{{menu_item.display}}</span>
            </router-link>
            <span class="nav-link d-flex align-items-center justify-content-center px-12 py-4">
              <div>
                <span><img :src="require('@/assets/language_globe.png')" width="25" style="filter: invert(67%) sepia(84%) saturate(280%) hue-rotate(353deg) brightness(106%) contrast(89%);" ></span>
                <span class="pl-1">EN</span>
              </div>
            </span>
          </div>
        </div>
      </div>
    </v-app-bar>


    <!-- --------------------------------------------- -->

    <v-main>
      <router-view />
    </v-main>
    
    <section id="footer-bottom" class="bg-darkgrey">
      <div class="container">
        <footer class="py-12">
          <div class="row">
            <div class="col-lg-4">
              <h5 class="fw-bold">CORPORATE PROFILE</h5>
              <div>
                <a class="nav-link" href="/corporate-profile">Our Story & Introduction</a>
                <a class="nav-link" href="/corporate-profile#ourbusinessoffering">Our Business Offering</a>
                <a class="nav-link" href="/corporate-profile#proudmember">Our Accreditations</a>
              </div>
              <br />
              <br />
              <h5 class="fw-bold">CONTACT US</h5>
              <div>
                <div>NAS BIZADVISORY PTE. LTD.</div>
                <div>1 Yishun Industrial Street 1</div>
                <div>#03-01 A'Posh Bizhub</div>
                <div>Singapore 768160</div>
                <br />
                <div>Call: +65 9114 2462</div>
                <div>
                  <span> <a class="secondary-color-text email-link" href="mailto:nas@nasbizadvisory.com">nas@nasbizadvisory.com</a></span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 mt-lg-0 mt-4">
              <div class="footer-links">
                <div><a href="/events" class="h5 fw-bold">EVENTS</a></div>
                <div><a href="/opportunities" class="h5 fw-bold">OPPORTUNITIES</a></div>
                <br />
                <div><a href="/terms-and-conditions" class="h5 fw-bold">TERMS & CONDITIONS</a></div>
                <div><a href="/privacy-policy" class="h5 fw-bold">PRIVACY POLICY</a></div>
                <br />
              </div>
            </div>
            <div class="offset-lg-1 col-lg-4 mt-lg-0 mt-4" id="contact-us-footer-form">
              <h5 class="mb-6 fw-bold">FREE CONSULTATION CALL BACK</h5>
              <div>
                <div id="contact-us-form" >
                  <input type="text" class="form-control rounded-0 my-3" placeholder="Name" name="contactName" v-model="c_full_name" required />
                  <input type="email" class="form-control rounded-0 my-3" placeholder="Email" name="contactEmail" v-model="c_email" required />
                  <input type="text" class="form-control rounded-0 my-3" placeholder="Contact No" name="contactNumber" v-model="c_contact_number" required />

                  <v-select class="select-input" density="compact" label="Preferred Time to call" :items="['9am - 12pm', '2pm - 5pm']" v-model="c_preferred_call_time">
                  </v-select>

                  <button class="btn mt-2 btn-outline-light rounded-0" id="request-callback-button" @click="submit_form">REQUEST CALLBACK</button>
                </div>
              </div>
              <div class="company-negative-margin mt-lg-12 mt-3">© 2023 Nas BizAdvisory Pte Ltd. All Rights Reserved.</div>
            </div>
          </div>
          <!-- <div class="text-end company-negative-margin mt-lg-0 mt-3">© 2023 Nas BizAdvisory Pte Ltd. All Rights Reserved. -->
        </footer>
      </div>
    </section>
  </v-app> 
</template>

<style src="./App.css"></style>
<style src="./bootstrap.min.css"></style>
<style>
.select-input {
  display: block;
  width: 100%;
  background-color: var(--bs-body-bg);
  color: var(--bs-body-color);
  
}
.select-input .v-label {
  color: var(--bs-body-color) !important;
  font-weight: 400;
  opacity: 0.87;
}
.select-input .v-input__details {
  background-color: var(--nav-footer-bg);
}
</style>

<script>
import { useRoute } from "vue-router";
import { ref } from "vue";
import { useDisplay } from "vuetify";
import {submitContactForm} from "./composables/FormSubmission"
export default {
  setup() {
    // vuetify display mobile resonsive
    const { mobile, width } = useDisplay();
    const drawer = ref(false);
    const vp_width = width

    const route = useRoute();

    const app_bar_menu = [
      {
        display: "CORPORATE PROFILE",
        link: "/corporate-profile",
      },
      {
        display: "EVENTS",
        link: "/events",
      },
      {
        display: "OPPORTUNITIES",
        link: "/opportunities",
      },
      {
        display: "CONTACT",
        link: "/contact-us",
      },
    ];

    // submit form @ footer
    const c_email = ref()
    const c_full_name = ref()
    const c_contact_number = ref()
    const c_preferred_call_time = ref()

    const submit_form = ()=>{
      const data_dict = {
        c_full_name: c_full_name.value,
        c_email: c_email.value,
        c_contact_number: c_contact_number.value,
        c_preferred_call_time: c_preferred_call_time.value,
      }
      // data validation
      if(!c_full_name.value || !c_email.value || !c_contact_number.value || !c_preferred_call_time.value){
        alert("Please fill in all the fields and try again.")
        return
      }
      // invoke composable function to submit form data
      submitContactForm(data_dict)
    }

    return {
      // UI layout
      app_bar_menu,
      route,
      // mobile responsive
      mobile,
      drawer,
      vp_width,
      // form footer
      c_email,
      c_full_name,
      c_contact_number,
      c_preferred_call_time,
      submit_form,
    }
  },
}
</script>